import { useContext, useMemo } from 'react';
import { ThemeContext } from 'styled-components';
import { makeDefaultTheme } from './themes';
import { makeArmorSubTheme } from './theme/makeArmorSubTheme';

var useStyledComponentsTheme = function useStyledComponentsTheme() {
  return useContext(ThemeContext);
};

export var useTheme = function useTheme(theme) {
  var styledComponentsTheme = useStyledComponentsTheme();
  return useMemo(function () {
    if (theme) {
      return theme;
    }

    if (styledComponentsTheme) {
      if (!styledComponentsTheme.armor || !styledComponentsTheme.armor.$initialized) {
        styledComponentsTheme.armor = makeArmorSubTheme(styledComponentsTheme.armor);
      }

      return styledComponentsTheme;
    }

    return makeDefaultTheme();
  }, [theme, styledComponentsTheme]);
};